<template>
  <div class="login">登录中。。。{{ $route.query.code }}</div>
</template>

<script>
import { getAccessToken } from '@/api/api.js'
export default {
  name: 'Login',
  data() {
    return {}
  },
  created() {
    
    // console.log(this.$route.query)
    if (this.$route.query.code) {
      this.getAccessTokenMeds()
    }
  },
  methods: {
    async getAccessTokenMeds() {
      const data = await getAccessToken(this.$route.query.code)
      console.log('login', data)
      console.log('login', data.data)
      this.$router.push({
        path: '/hxpay',
        query: { openid: data?.data?.openid, activityNumber: this.$route.query.activityNumber }
      })
    }
  }
}
</script>
<style lang="less" scoped></style>
